<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import Fingerprint2 from "fingerprintjs2";
// import { md5 } from "@/utils/index";
// import { getABTest } from "@/api/home";
// import { setCookie, getCookie } from "@/utils/token";

export default {
  name: "App",
  data() {
    return {
      fingerprint: "",
    };
  },
  async mounted() {
    window.TAL_UC.rankConfig({
      "client-id": "1031102",
      domain: "passport.laoshibang.com",
      success(res) {
        console.log(res, "登陆");
      },
      fail(err) {
        // 失败回调函数
        console.log("rankConfig-fail", err);
      },
      complete() {
        console.log("rankConfig-complete");
      },
    });
    // // 如果路由有strategy参数，则设置AB测试信息
    // const strategyData = this.$route.query.strategy;
    // if (strategyData) {
    //   this.$store.dispatch("app/setABTestInfo", {
    //     strategy: strategyData,
    //   });
    //   localStorage.setItem(
    //     "abTestInfo",
    //     JSON.stringify({ strategy: strategyData })
    //   );
    //   return;
    // }
    // if (!localStorage.getItem("fingerprint") && !getCookie("fingerprint")) {
    //   await this.generateFingerprint();
    // } else {
    this.getABTestInfo();
    // }
  },
  beforeDestroy() {},
  methods: {
    // generateFingerprint() {
    //   // 检查浏览器是否支持 requestIdleCallback（优化性能，避免阻塞主线程）
    //   if (window.requestIdleCallback) {
    //     requestIdleCallback(() => {
    //       this.createFingerprint();
    //     });
    //   } else {
    //     // 不支持则延迟执行
    //     setTimeout(() => {
    //       this.createFingerprint();
    //     }, 500);
    //   }
    // },
    // createFingerprint() {
    //   // 配置指纹生成选项（可选，默认会收集多种特征）
    //   const options = {
    //     excludes: {
    //       // 可选：排除某些特征（如 userAgent、language 等）
    //       // userAgent: true,
    //       // language: true
    //     },
    //     // 更多配置可参考官方文档：https://github.com/Valve/fingerprintjs2
    //   };

    //   try {
    //     // 生成指纹
    //     Fingerprint2.get(options, (components) => {
    //       try {
    //         // components 是一个数组，包含所有用于生成指纹的特征（如浏览器信息、设备信息等）
    //         const values = components.map((component) => component.value);
    //         // 将特征组合成一个字符串，再通过哈希算法生成最终指纹（如 md5）
    //         const murmur = Fingerprint2.x64hash128(values.join(""), 31);
    //         this.fingerprint = murmur;
    //         console.log("生成的浏览器指纹：", this.fingerprint);
    //         localStorage.setItem("fingerprint", this.fingerprint);
    //         setCookie("fingerprint", this.fingerprint, 90);
    //         this.getABTestInfo();
    //       } catch (error) {
    //         console.warn("指纹处理失败，使用随机默认值：", error);
    //         this.generateRandomFingerprint();
    //       }
    //     });
    //   } catch (error) {
    //     console.warn("指纹生成失败，使用随机默认值：", error);
    //     this.generateRandomFingerprint();
    //   }
    // },
    // generateRandomFingerprint() {
    //   // 生成随机指纹：时间戳 + 随机数 + 用户代理简化版
    //   const timestamp = Date.now().toString(36);
    //   const randomNum = Math.random().toString(36).substr(2, 9);
    //   const userAgent = navigator.userAgent
    //     ? navigator.userAgent.length.toString(36)
    //     : "unknown";
    //   const screenInfo = `${screen.width}x${screen.height}`;
    //   const language = navigator.language || "zh-CN";

    //   // 组合生成随机指纹
    //   const randomFingerprint = md5(
    //     `${timestamp}-${randomNum}-${userAgent}-${screenInfo}-${language}`
    //   );

    //   this.fingerprint = randomFingerprint;
    //   console.log("使用随机默认指纹：", this.fingerprint);
    //   localStorage.setItem("fingerprint", this.fingerprint);
    //   setCookie("fingerprint", this.fingerprint, 90);
    //   this.getABTestInfo();
    // },
    getABTestInfo() {
      //Lsb_ab_test_info_+$timestamp+"_"+$devId 然后计算MD5
      //token计算方式：
      //md5(Lsb_ab_test_info_1112223123_asdasdasdasdada)
      // const devId =
      //   localStorage.getItem("fingerprint") || getCookie("fingerprint");
      // const timestamp = Math.floor(Date.now() / 1000);
      // const token = md5(`Lsb_ab_test_info_${timestamp}_${devId}`);
      // const params = {
      //   devId,
      //   token, //时间戳开始时间
      //   timestamp,
      // };
      // console.log("params fingerprint", params, devId);
      // getABTest(params)
      //   .then((res) => {
      //     console.log(res, "AB测试");
      // if (res.code === 200) {
      //   abTestInfo = res?.data || { strategy: "A" };
      // }
      let abTestInfo = { strategy: "A" };
      this.$store.dispatch("app/setABTestInfo", abTestInfo);
      localStorage.setItem("abTestInfo", JSON.stringify(abTestInfo));
      // AB测试信息获取完成，HomeRouter 组件会自动根据 strategy 显示对应的组件
      // })
      // .catch((err) => {
      //   console.log(err, "AB测试接口调用失败");
      //   this.$store.dispatch("app/setABTestInfo", { strategy: "B" });
      //   localStorage.setItem("abTestInfo", JSON.stringify({ strategy: "B" }));
      // });
    },
  },
};
</script>
<style lang="scss" scoped></style>
